module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/marthastewartweddings-adf9bbf76010e6e95d02ab44676f9284.png";